import React, { Component, createRef } from "react";
import InventoryServices from "../../services/axioServices/apiServices/InventoryServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import moment from "moment";
import * as XLSX from 'xlsx';
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";
import { printFunction } from "../../components/print/printTemplate.js";

class ShortageReport extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.inventoryServices = new InventoryServices();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.state = {
            companyName: '',
            totalCount: 0,
            tableStatus: "",
            filterDetails: {
                materialType: 'Raw Material',
            },
            noItemFound: "",
            shourtageRecordsList: [],
            typeList: [
                { material: 'Raw Material' },
                { material: 'Packing Material' },
            ],
        }
    }

    componentDidMount() {
        const company = getAuthProps()
        this.setState({ companyName: company?.companyName })
    }

    handleDropdownChange = (e, name) => {
        const value = e.target.value;
        let details = this.state.filterDetails;
        details[name] = value;
        this.setState({ filterDetails: details });
    };

    getAllShourtageReport = () => {
        this.setState({ tableStatus: "Loading..." })
        let request = this.state.filterDetails
        this.inventoryServices.getAllShourtageReport(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                if (response.responseData.length === 0) {
                    this.setState({ tableStatus: "No Record Found" })
                } else {
                    this.setState({ tableStatus: "" })
                }
                let totalCount = response.responseData.length
                if (totalCount === 0) {
                    this.setState({ noItemFound: "No Records Found" })
                }
                this.setState({ shourtageRecordsList: response.responseData, totalCount: totalCount })
            } else {
                this.setState({ tableStatus: "" })
                this.SwalServices.Error(response.Message);
            }
        })
    }

    render() {
        return (
            <div className="shortageReport-page reports-page">
                <div className="item-search !mb-[10px]">
                    <div className="item-grp">
                        <div className="item-inner-grp justify-between">
                            <div className="material-selector !w-[30%]">
                                <label>Material Type</label>
                                <select
                                    value={this.state.filterDetails.materialType}
                                    onChange={(e) =>
                                        this.handleDropdownChange(e, "materialType")
                                    }
                                >
                                    {this.state.typeList.map((x, key) => (
                                        <option key={key} value={x.material}>
                                            {x.material}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="btn-grp mt-3.5">
                                <button class="add-btn" onClick={() => this.getAllShourtageReport()}>Search</button>
                                {this.state.shourtageRecordsList &&
                                    this.state.shourtageRecordsList.length > 0 ? (
                                    <button class="print-btn" onClick={() => printFunction()}>Print</button>
                                ) : null}
                            </div>

                        </div>
                    </div>
                </div>
                <div >
                    <p className=" mb-[3px] text-[15px] font-medium text-[#474747]" >Total Count :- {this.state.totalCount ? this.state.totalCount : 0}</p>
                </div>
                <div class="item-listing">
                    <div className="hidden print-title">
                        <h4>Shortage Report</h4>
                        <p>Material type:- {this.state.filterDetails.materialType}</p>
                    </div>
                    <div class="itemList-table">
                        <div class="table-container" style={{ height: "calc(100vh - 200px)" }}>
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td style={{ width: "10%" }} className="w-[10%]">Sr.</td>
                                        <td style={{ width: "42%" }} className="w-[42%]">Material Name</td>
                                        <td style={{ width: "8%" }} className="w-[8%]">Unit</td>
                                        <td style={{ width: "16%" }} className="w-[16%]">Stock</td>
                                        <td style={{ width: "16%" }} className="w-[16%]">Min. Level</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.shourtageRecordsList && this.state.shourtageRecordsList.length > 0 ?
                                        this.state.shourtageRecordsList.map((details, key) => (

                                            <tr key={key}>
                                                <td>{key + 1}</td>
                                                <td>{details.materialName}</td>
                                                <td>{details.uom}</td>
                                                <td>{details.stock}</td>
                                                <td>{details.minQty}</td>
                                            </tr>

                                        )) : this.state.shourtageRecordsList &&
                                            this.state.shourtageRecordsList.length === 0
                                            && this.state.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.tableStatus}
                                                </td>
                                            </tr>
                                        ) : this.state.shourtageRecordsList &&
                                            this.state.shourtageRecordsList.length === 0
                                            && this.state.tableStatus === "" ? null : ""}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/*----- Print layout -----*/}
                <div className='table-print mt-5 hidden' id="printableArea">
                    {/* Header */}
                    <div className="print-header">
                        <table className="hdr-table">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="co-name">{this.state.companyName}</div>
                                        <div className="rpt-sub">Shortage Report</div>
                                    </td>
                                    <td>
                                        <div className="hdr-meta">
                                            Material Type: <strong>{this.state.filterDetails.materialType}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="rule-thick" />
                        <div className="rule-thin" />
                    </div>


                    <div className="print-content">

                        {/* <div className="info-row">
                                      <div>
                                        <span className="info-label">Item Name:</span>
                                        <p className="info-value">Paracetamol</p>
                                      </div>
                                    </div> */}

                        {/* Table */}
                        <table className="data-tbl">
                            <colgroup>
                                <col style={{ width: "15%" }} />
                                <col style={{ width: "40%" }} />
                                <col style={{ width: "15%" }} />
                                <col style={{ width: "15%" }} />
                                <col style={{ width: "15%" }} />
                            </colgroup>

                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left' }}>
                                        Sr No
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Material Name
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Unit
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Stock
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Min. Level
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {this.state.shourtageRecordsList && this.state.shourtageRecordsList.length > 0 ?
                                    this.state.shourtageRecordsList.map((details, key) => (
                                        <tr key={key}>
                                            <td style={{ textAlign: 'left' }}>
                                                {key + 1}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.materialName}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.uom}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.stock}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.minQty}
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="5" style={{ textAlign: 'center' }}>
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer */}
                    <div className="print-footer">
                        <div className="rule-foot">
                            <table className="foot-tbl">
                                <tbody>
                                    <tr>
                                        <td>* System generated report. No signature required.</td>
                                        <td style={{ textAlign: "right" }}>
                                            Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}
export default ShortageReport;
